export default {"src":"/_next/static/media/football.68f0cd26.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};